import { useState, useEffect } from 'react';

export const useCountUp = (end, duration = 2000) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        // end 값이 유효한 숫자인지 확인
        if (!end || isNaN(end)) return;

        // 시작값을 0으로 초기화
        setCount(0);

        const startTime = Date.now();
        const endValue = parseInt(end);

        const updateCount = () => {
            const currentTime = Date.now();
            const elapsedTime = currentTime - startTime;

            if (elapsedTime < duration) {
                // 진행 비율 계산 (0 ~ 1)
                const progress = elapsedTime / duration;
                
                // 이징 함수 적용 (선택사항)
                const easeProgress = 1 - Math.pow(1 - progress, 3);
                
                // 현재 값 계산
                const currentValue = Math.round(endValue * easeProgress);
                
                setCount(currentValue);
                requestAnimationFrame(updateCount);
            } else {
                setCount(endValue);
            }
        };

        requestAnimationFrame(updateCount);

        // 클린업 함수
        return () => {
            setCount(endValue);
        };
    }, [end, duration]);

    // 숫자를 천 단위로 콤마 추가하여 반환
    return count.toLocaleString();
};